export class ServerError extends Error {
  readonly contextId: string;
  readonly status?: number;
  constructor(message = 'Server error', contextId: string, status?: number) {
    super(message);
    this.name = 'ServerError';
    this.contextId = contextId;
    this.status = status;
  }
}
